module.exports = __webpack_public_path__ + "static/img/radius-bg.8267cefc.png";